import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import Menu from "./Menu"
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { NavLink } from "react-router-dom";
import Masonry from "react-masonry-css";
import CheckIcon from "@material-ui/icons/Check";
import { withStyles } from "@material-ui/core/styles";
import { purple } from "@material-ui/core/colors";
import Switch from "@material-ui/core/Switch";
import { connect } from "react-redux";
import LoyaltyRoundedIcon from "@material-ui/icons/LoyaltyRounded";
import { logoutUser, toogleDrawer } from "../actions/authActions";
import SearchIcon from "@material-ui/icons/Search";
import Box from '@material-ui/core/Box';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import {
    setThemeDark,
    setThemeLight,
    toggletheme,
} from "../actions/mainAction";
import "./Styles.css";
import {
    Grid,
    Card,
    CardMedia,
    CardActionArea,
    CardContent,
    TextField,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment,
} from "@material-ui/core";
import PostItem from "./PostItem";
import ShowMoreText from "react-show-more-text";
import Footer from "./Footer";
import { getPostScroll } from "../actions/productActions";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import StarsIcon from "@material-ui/icons/Stars";

const drawerWidth = 240;
const breakpointColumnsObj = {
    default: 4,
    1300: 3,
    950: 2,
    650: 1,
};
const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        "&$checked": {
            transform: "translateX(16px)",
            color: theme.palette.common.white,
            "& + $track": {
                backgroundColor: "#52d869",
                opacity: 1,
                border: "none",
            },
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {

    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 160,
    },

    menuButton: {
        marginRight: theme.spacing(2),

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        // marginLeft: window.innerWidth > 700 ? "15rem" : "0",s
    },
    root: {
        marginBottom: "3rem",
        padding: "1px",
        borderRadius: "0.5rem",
        maxWidth: 345,
        margin: "auto",
        transition: "0.3s",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)",
        },
    },
    media: {
        height: "250px",
        width: "94%",
        maxWidth: "400px",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        margin: "9px",
    },
    boxheader: {
        height: "2.5rem"
    }

}));


function Home(props) {
    const [Products, setProducts] = useState([]);
    const [page, setpage] = useState(2);
    const [hasmore, sethasmore] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [Switch, setSwitch] = useState(false);
    const [ButtonLoading, setButtonLoading] = useState(false);
    const [filter, setfilter] = useState([]);
    const [filterCondition, setfilterCondition] = useState("");
    const [subData, setsubData] = useState("");
    // let filter = [];
    const [SubCats, setSubCats] = useState([]);
    useEffect(() => {
        if (!subData == "") {
            setfilter(
                props.products.posts.filter(function (item) {
                    return (
                        item.category == filterCondition &&
                        item.subcategory == subData
                    );
                })
            );
        } else if (props.products.posts.length > 0) {
            setfilter(
                props.products.posts.filter(function (item) {
                    return (
                        item.category == filterCondition
                        // item.subcategory == subData
                    );
                })
            );
        }
    }, [filterCondition, subData]);

    useEffect(() => {
        props.category.cats.map(function (item) {
            if (item.category === filterCondition) {
                setSubCats(item.subcategories);
            }
        });
    }, [filterCondition]);
    console.log(SubCats, "subs");
    console.log(filter);
    if (props.Button) console.log(Products, "pro");
    useEffect(() => {
        // props.getPostScroll(1);
    }, []);
    const loadMore = () => {
        setpage(page + 1);
        setButtonLoading(true);
        props.getPostScroll(page);
    };

    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    console.log(props.main.theme, "theme");
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };



    const getRandomImages = () => {
        return (Math.floor(Math.random() * 20));
    }




    const [search, setSearch] = React.useState("");
    let FilteredPosts = props.products.posts.filter((post) => {
        return post.pname.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
    const drawer = (
        <div>
            <div
            // className={classes.toolbar}

            />
            <Box className={classes.boxheader}>
                <Typography variant="h6" style={{ marginTop: "1rem" }} align="center">{props.website.website.header}</Typography>
            </Box>
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem button selected={true}>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>
                {props.auth.isAuthenticated ? (
                    <NavLink to="/cart" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <ShoppingCartRoundedIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Cart"} />
                        </ListItem>
                    </NavLink>
                ) : null}
                {props.auth.isAuthenticated ? (
                    <NavLink to="/wishlist" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <StarsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Wishlist"} />
                        </ListItem>
                    </NavLink>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>

                <ListItem button>
                    <ListItemIcon>
                        <IOSSwitch
                            checked={props.main.theme == "dark"}
                            onChange={() => {
                                props.toggletheme();
                            }}
                            name="checkedB"
                        />
                    </ListItemIcon>
                    <ListItemText primary={"Dark Mode"} />
                </ListItem>
            </List>
        </div>
    );

    const container =
        window !== undefined ? () => window().document.body : undefined;

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => {
                            props.toogleDrawer()
                        }}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        align="center"
                        // noWrap
                        style={{
                            fontFamily: " 'Berkshire Swash', cursive",
                            // border: "1px solid",
                            width: "100%",
                        }}
                    >
                        {props.website.website
                            ? props.website.website.header
                            : ""}
                    </Typography>
                    {props.auth.isAuthenticated ? (
                        <Button
                            color="inherit"
                            onClick={() => props.logoutUser()}
                        >
                            logout
                        </Button>
                    ) : (
                            <NavLink
                                to="/login"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                <Button color="inherit">Login</Button>
                            </NavLink>
                        )}
                </Toolbar>
            </AppBar>
            <Menu />

            <main className={classes.content}>
                <div className={classes.toolbar} />

                <Box style={{ marginBottom: "2rem" }}>
                    <AwesomeSlider class="aws-btn" bullets={false}>
                        <div data-src={`https://source.unsplash.com/user/insideweather?sig=${getRandomImages()}`} />
                        <div data-src={`https://source.unsplash.com/user/insideweather?sig=${getRandomImages()}`} />
                        <div data-src={`https://source.unsplash.com/user/insideweather?sig=${getRandomImages()}`} />
                        <div data-src={`https://source.unsplash.com/user/insideweather?sig=${getRandomImages()}`} />
                        <div data-src={`https://source.unsplash.com/user/insideweather?sig=${getRandomImages()}`} />
                    </AwesomeSlider>
                </Box>
                <TextField
                    style={{ marginBottom: "0.7rem" }}
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="input-with-icon-textfield"
                    placeholder="search product by name..."
                    color="primary"
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value.substr(0, 20));
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ marginBottom: "1rem" }}
                >
                    <InputLabel id="demo-simple-select-outlined-label">
                        Select Category
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={filterCondition}
                        onChange={(event) =>
                            setfilterCondition(event.target.value)
                        }
                        label="Select Category"
                    >
                        <MenuItem value="">
                            <em>all</em>
                        </MenuItem>
                        {props.category.cats.map((cat) => (
                            <MenuItem value={cat.category}>
                                {cat.category}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                >
                    <InputLabel id="demo-simple-select-outlined-label">
                        Select SubCat
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={subData}
                        onChange={(event) => setsubData(event.target.value)}
                        label="Select Category"
                    >
                        <MenuItem value="">
                            <em>all</em>
                        </MenuItem>
                        {SubCats.map((cat) => (
                            <MenuItem value={cat.subcategory}>
                                {cat.subcategory}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {Loading ? (
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: "10rem" }}
                    >
                        <CircularProgress color="primary" size={80} />
                    </Grid>
                ) : (
                        <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                        >
                            {/* {Products.map((post) => (
                            <PostItem key={post._id} post={post} />
                        ))} */}
                            {filterCondition === ""
                                ? FilteredPosts.map((product) => (
                                    <NavLink to={`/product/${product._id}`}>
                                        <Card
                                            variant="outlined"
                                            key={product._id}
                                            className={classes.root}
                                        >
                                            {/* <Paper elevation={10}> */}
                                            <CardActionArea>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={product.image1}
                                                    title="Contemplative Reptile"
                                                />
                                            </CardActionArea>
                                            <CardContent>
                                                <Typography
                                                    gutterBottom
                                                    variant="h5"
                                                    component="h2"
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {product.pname}
                                                </Typography>
                                                <Typography
                                                    gutterBottom
                                                    color="primary"
                                                    variant="h6"
                                                    component="h2"
                                                >
                                                    ₹ {product.price}
                                                </Typography>
                                                {/* <div className="scrollhost"> */}
                                                {/* <Typography style={{ maxHeight: "5rem" }}>
                                        {product.text}
                                    </Typography> */}

                                                <div
                                                    style={{
                                                        wordWrap:
                                                            "break-word",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        component="p"
                                                        style={{
                                                            fontFamily:
                                                                "Roboto,sans-serif",
                                                            fontSize: "1rem",
                                                            // fontWeight: "bold",
                                                            overflow: "auto",
                                                            maxWidth:
                                                                "21.6rem",
                                                            // border: "0.5px solid"
                                                        }}
                                                    >
                                                        {/* {post.text} */}
                                                        <div
                                                            style={{
                                                                textDecoration:
                                                                    "none",
                                                                color:
                                                                    "inherit",
                                                            }}
                                                        >
                                                            <ShowMoreText
                                                                /* Default options */
                                                                lines={3}
                                                                more={
                                                                    "read more"
                                                                }
                                                                less="read less"
                                                                anchorClass={
                                                                    classes.post
                                                                }
                                                                // onClick={executeOnClick}
                                                                expanded={
                                                                    false
                                                                }
                                                                width={345.6}
                                                            >
                                                                <TextField
                                                                    style={{
                                                                        marginTop:
                                                                            "0.3rem",
                                                                        // fontSize: "2rem"
                                                                    }}
                                                                    disabled
                                                                    multiline
                                                                    fullWidth
                                                                    color="secondary"
                                                                    variant="outlined"
                                                                    value={
                                                                        product.text
                                                                    }
                                                                    name="text"
                                                                    rowsMax={
                                                                        10
                                                                    }
                                                                ></TextField>
                                                            </ShowMoreText>
                                                        </div>
                                                    </Typography>
                                                </div>
                                                {/* </div>  */}
                                                <Divider />
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="flex-end"
                                                    alignItems="center"
                                                >
                                                    <Button
                                                        style={{
                                                            marginTop:
                                                                "0.5rem",
                                                            fontSize:
                                                                "0.5rem",
                                                            // marginLeft: "auto",
                                                            borderRadius:
                                                                "2rem",
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                        // className={classes.button}
                                                        size="small"
                                                        startIcon={
                                                            <CheckIcon />
                                                        }
                                                    >
                                                        {product.category}{" "}
                                                    </Button>
                                                            &nbsp;&nbsp;
                                                            {product.subcategory ? <Button
                                                        style={{
                                                            marginTop:
                                                                "0.5rem",
                                                            fontSize:
                                                                "0.5rem",
                                                            // marginLeft: "auto",
                                                            borderRadius:
                                                                "2rem",
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                        // className={classes.button}
                                                        size="small"
                                                        startIcon={
                                                            <LoyaltyRoundedIcon />
                                                        }
                                                    >
                                                        {product.subcategory}{" "}
                                                    </Button>

                                                        : null}

                                                </Grid></CardContent>
                                            {/* </CardActionArea> */}

                                            {/* <CardActions>
                                    <Grid container justify="center" alignItems="center">
                                        <IconButton >
                                            <VisibilityRoundedIcon color="primary" />
                                        </IconButton>   </Grid>   </CardActions> */}
                                            {/* </Paper> */}
                                        </Card>
                                    </NavLink>
                                ))
                                : filter.map((product) => (
                                    <NavLink to={`/product/${product._id}`}>
                                        <Card
                                            variant="outlined"
                                            key={product._id}
                                            className={classes.root}
                                        >
                                            {/* <Paper elevation={10}> */}
                                            <CardActionArea>
                                                <CardMedia
                                                    className={classes.media}
                                                    image={product.image1}
                                                    title="Contemplative Reptile"
                                                />

                                                <CardContent>
                                                    <Typography
                                                        gutterBottom
                                                        variant="h5"
                                                        component="h2"
                                                        style={{
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {product.pname}
                                                    </Typography>
                                                    <Typography
                                                        gutterBottom
                                                        color="primary"
                                                        variant="h6"
                                                        component="h2"
                                                    >
                                                        ₹ {product.price}
                                                    </Typography>
                                                    {/* <div className="scrollhost"> */}
                                                    {/* <Typography style={{ maxHeight: "5rem" }}>
                                        {product.text}
                                    </Typography> */}

                                                    <div
                                                        style={{
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            color="textSecondary"
                                                            component="p"
                                                            style={{
                                                                fontFamily:
                                                                    "Roboto,sans-serif",
                                                                fontSize: "1rem",
                                                                // fontWeight: "bold",
                                                                overflow: "auto",
                                                                maxWidth:
                                                                    "21.6rem",
                                                                // border: "0.5px solid"
                                                            }}
                                                        >
                                                            {/* {post.text} */}
                                                            <div
                                                                style={{
                                                                    textDecoration:
                                                                        "none",
                                                                    color:
                                                                        "inherit",
                                                                }}
                                                            >
                                                                <ShowMoreText
                                                                    /* Default options */
                                                                    lines={3}
                                                                    more={
                                                                        "read more"
                                                                    }
                                                                    less="read less"
                                                                    anchorClass={
                                                                        classes.post
                                                                    }
                                                                    // onClick={executeOnClick}
                                                                    expanded={
                                                                        false
                                                                    }
                                                                    width={345.6}
                                                                >
                                                                    <TextField
                                                                        style={{
                                                                            marginTop:
                                                                                "0.3rem",
                                                                            // fontSize: "2rem"
                                                                        }}
                                                                        disabled
                                                                        multiline
                                                                        fullWidth
                                                                        color="secondary"
                                                                        variant="outlined"
                                                                        value={
                                                                            product.text
                                                                        }
                                                                        name="text"
                                                                        rowsMax={
                                                                            10
                                                                        }
                                                                    ></TextField>
                                                                </ShowMoreText>
                                                            </div>
                                                        </Typography>
                                                    </div>
                                                    {/* </div>  */}
                                                    <Divider />
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="flex-end"
                                                        alignItems="center"
                                                    >
                                                        <Button
                                                            style={{
                                                                marginTop:
                                                                    "0.5rem",
                                                                marginRight:
                                                                    "0.5rem",
                                                                fontSize:
                                                                    "0.5rem",
                                                                // marginLeft: "auto",
                                                                borderRadius:
                                                                    "2rem",
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                            // className={classes.button}
                                                            size="small"
                                                            startIcon={
                                                                <CheckIcon />
                                                            }
                                                        >
                                                            {product.category}{" "}
                                                        </Button>

                                                        {product.subcategory ? <Button
                                                            style={{
                                                                marginTop:
                                                                    "0.5rem",
                                                                fontSize:
                                                                    "0.5rem",
                                                                // marginLeft: "auto",
                                                                borderRadius:
                                                                    "2rem",
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                            // className={classes.button}
                                                            size="small"
                                                            startIcon={
                                                                <LoyaltyRoundedIcon />
                                                            }
                                                        >
                                                            {product.subcategory}
                                                        </Button>

                                                            : null}
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>

                                            {/* <CardActions>
                                    <Grid container justify="center" alignItems="center">
                                        <IconButton >
                                            <VisibilityRoundedIcon color="primary" />
                                        </IconButton>   </Grid>   </CardActions> */}
                                            {/* </Paper> */}
                                        </Card>
                                    </NavLink>
                                ))}
                        </Masonry>
                    )}
                <Grid container justify="center" alignItems="center">
                    {props.products.has_more ? (
                        props.products.loading ? (
                            <Button
                                color="primary"
                                variant="outlined"
                                disabled={true}
                            >
                                <CircularProgress color="primary" />
                            </Button>
                        ) : (
                                <Button
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => loadMore()}
                                >
                                    Loadmore
                                </Button>
                            )
                    ) : null}
                </Grid>
            </main>
            <Footer />
        </div>
    );
}
const mapStateToProps = (state) => ({
    main: state.main,
    products: state.products,
    category: state.category,
    website: state.website,
    auth: state.auth,
});
export default connect(mapStateToProps, {
    setThemeDark,
    setThemeLight,
    toggletheme,
    getPostScroll,
    logoutUser,
    toogleDrawer
})(Home);
